import Controller, { OnBeforeFetch, OnBlur, OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../../../constants/endpoints';
import ShowToast from '../../../utils/toast-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';

import { AutocompleteAPI, CheckboxAPI, FetchAPI, FieldAPI, ModalService, PanelAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { CLINICAL_NOTES_MSG_COOKIE_KEY, ClinicalNotesMsgStatus } from '../clinical-note-service-constants';
import { ClinicalNotesInstitutionStandardTextAliases } from '../../../codegen/constants/aliases/clinical-notes-institution-standard-text-aliases';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { StandardText } from '../clinical-notes-types';

interface StandardTextGroupAutoCompleteProps {
  dsGrupo: string;
  nrSeqGrupo: number;
}

interface ClinicalNotesTypeAutoCompleteProps {
  cdTipoEvolucao: string;
  dsCor: string;
  dsTipoEvolucao: string;
  ieEspecParecer: string;
  ieObrigarPessoaParecer: string;
}

interface MedicalSpecialtyAutoCompleteProps {
  cdEspecialidade: number;
  dsEspecialidade: string;
}

interface StandardTextAutoCompleteProps {
  dsTitulo: string;
  nrTextoPadrao: number;
}

@Controller({ component: 'layout-institution-standard-text', fragment: 'clinical-notes-institution-standard-text' })
class ClinicalNotesInstitutionStandardTextController extends BaseController {

  @Inject(ClinicalNotesInstitutionStandardTextAliases.FETCH_STANDARD_TEXT)
  fecthStandardText!: FetchAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.AUTOC_STANDARD_TEXT_GROUP)
  autocGroup!: AutocompleteAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.AUTOC_CLINICAL_NOTES_TYPE)
  autoClinicalNoteType!: AutocompleteAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.AUTOC_MEDICAL_SPECIALTY)
  autoMedicalSpecialty!: AutocompleteAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.AUTOC_STANDARD_TEXT)
  autocStandardText!: AutocompleteAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.PANEL_MESSAGE_ACCEPT)
  panelMessageAcceptApi!: PanelAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.PANEL_LOADER)
  panelLoaderApi!: PanelAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.PANEL_ACCEPT)
  panelAcceptApi!: PanelAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.PANEL_ACTIONS)
  panelActionsApi!: PanelAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.CHECKBOX_CLICNICAL_NOTES_MSG)
  checkbox!: CheckboxAPI;

  @Inject(ClinicalNotesInstitutionStandardTextAliases.FIELD_CLICNICAL_NOTES_MSG)
  checkboxField!: FieldAPI;

  nrAtendimento!: number;
  cdPessoaFisica!: string;
  nrSeqGrupo = 0;
  cdTipoEvolucao = '0';
  cdEspecialidade = 0;
  nrTextoPadrao!: number;
  dsTextoReplaced = '';

  showActionsLoadText(visible: boolean): void {
    this.panelLoaderApi.setVisible(!visible);
    this.panelMessageAcceptApi.setVisible(!visible);
    this.panelAcceptApi.setVisible(!visible);
    this.panelActionsApi.setVisible(visible);
  }

  showActionsAccept(visible: boolean): void {
    this.panelLoaderApi.setVisible(!visible);
    this.panelMessageAcceptApi.setVisible(visible);
    this.panelAcceptApi.setVisible(visible);
    this.panelActionsApi.setVisible(!visible);
  }

  close(): void {
    ModalService.close('clinical-notes-institution-standard-text');
  }

  getClinicalNotesMsgCookieValue(): string | undefined {
    const clinicalNotesMsgCookie = document.cookie.split(';').find(cookie => cookie.match(CLINICAL_NOTES_MSG_COOKIE_KEY));
    const clinicalNotesMsgCookieValue = clinicalNotesMsgCookie?.split('=')[1];
    return clinicalNotesMsgCookieValue;
  }

  dispatchAddStandardTextEvent(): void {
    const event = new CustomEvent('addStandardText', { detail: this.dsTextoReplaced });
    dispatchEvent(event);
  }

  @OnChange('checkbox-clicnical-notes-msg')
  onChangeCheckBox(): void {
    this.checkbox.setValue(!this.checkbox.getValue())
  }

  @OnMount({ target: 'layout-institution-standard-text' })
  onMount(): void {
    const { encounterId } = this.historyService.getCurrentRouteParams();
    const { patientId } = this.historyService.getCurrentRouteParams();

    this.nrAtendimento = encounterId as number;
    this.cdPessoaFisica = patientId as string;
    this.showActionsLoadText(true);

    this.context.set({
      cdEspecialidade: 0,
      cdTipoEvolucao: '0',
      nrAtendimento: this.nrAtendimento,
      nrSeqGrupo: 0,
    });

  }

  @OnClick({ target: 'standard-text-button-ok' })
  onButtonOkClick(): void {
    this.handleOkClick();
  }

  @OnClick({ target: 'standard-text-button-cancel' })
  onButtonCancelClick(): void {
    this.handleCancelClick();
  }

  @OnClick({ target: 'accept-custom-dynamic-button' })
  onAcceptCustomDynamicButtonMount(): void {
    this.handleAcceptClick();
  }

  @OnChange({ target: 'autoc-standard-text-group' })
  onGroupChange(event: ChangeEvent<StandardTextGroupAutoCompleteProps>): void {
    const { nrSeqGrupo } = event.value;

    this.context.set({
      nrSeqGrupo
    });

    this.showActionsLoadText(true);
  }

  @OnChange({ target: 'autoc-clinical-notes-type' })
  onClinicalNoteTypeChange(event: ChangeEvent<ClinicalNotesTypeAutoCompleteProps>): void {
    const { cdTipoEvolucao } = event.value;

    this.context.set({
      cdTipoEvolucao: cdTipoEvolucao
    });

    this.showActionsLoadText(true);
  }

  @OnChange({ target: 'autoc-medical-specialty' })
  onMedicalSpecialtyChange(event: ChangeEvent<MedicalSpecialtyAutoCompleteProps>): void {
    const { cdEspecialidade } = event.value;

    this.context.set({
      cdEspecialidade: cdEspecialidade || 0
    });

    this.showActionsLoadText(true);
  }

  @OnBlur({ target: 'autoc-standard-text-group' })
  onGroupBlur(): void {
    const value = this.autocGroup.getValue() as Record<string, Value>;

    if (!value || value.nrSeqGrupo === 0) {

      this.nrSeqGrupo = 0;

      this.context.set({
        nrSeqGrupo: 0
      });
    }
  }

  @OnBlur({ target: 'autoc-clinical-notes-type' })
  onClinicalNoteTypeBlur(): void {
    const value = this.autoClinicalNoteType.getValue() as Record<string, Value>;

    if (!value || value.cdTipoEvolucao === 0) {

      this.cdTipoEvolucao = '0';

      this.context.set({
        cdTipoEvolucao: '0'
      });
    }
  }

  @OnBlur({ target: 'autoc-medical-specialty' })
  onMedicalSpecialtyBlur(): void {
    const value = this.autoMedicalSpecialty.getValue() as Record<string, Value>;

    if (!value || value.cdEspecialidade === 0) {

      this.cdEspecialidade = 0;

      this.context.set({
        cdEspecialidade: 0
      });
    }
  }

  @OnBeforeFetch({ target: 'fetch-standard-text' })
  onStandardTextBeforeFetch(): void {
    this.autocStandardText.setValue({});
  }

  @OnChange({ target: 'autoc-standard-text' })
  onTextChange(event: ChangeEvent<StandardTextAutoCompleteProps>): void {
    const { nrTextoPadrao } = event.value;

    this.nrTextoPadrao = nrTextoPadrao || 0;
    this.showActionsLoadText(true);
  }

  handleCancelClick(): void {
    this.close();
  }

  handleOkClick(): void {
    const cdPessoaFisica = this.cdPessoaFisica;
    const nrAtendimento = this.nrAtendimento;
    const nrTextoPadrao = this.nrTextoPadrao;
    const standardTextType = 'INSTITUTION';

    if (nrTextoPadrao && nrTextoPadrao > 0) {

      this.panelLoaderApi.setVisible(true);

      const showClinicalNotesMsg = !(this.getClinicalNotesMsgCookieValue() === ClinicalNotesMsgStatus.DEACTIVATED);
      const params = { cdPessoaFisica, nrAtendimento, nrTextoPadrao, standardTextType };

      HttpService.get<StandardText>(
        Endpoint.GET_NOTAS_CLINICAS_STANDARD_TEXT,
        params
      ).then(response => {
        const body = response.body as StandardText
        this.dsTextoReplaced = body.dsTexto;
        this.showActionsAccept(true);

        if (!showClinicalNotesMsg) {
          this.dispatchAddStandardTextEvent();
          this.close();
        }
      }).catch(err => {
        this.showActionsLoadText(true);
        ShowToast.open(err?.body.errorMessage, ToastLevel.ERROR);
        this.close();
      });
    }
  }

  handleAcceptClick(): void {
    if (this.checkbox.getValue()) {
      document.cookie = `${CLINICAL_NOTES_MSG_COOKIE_KEY}=${ClinicalNotesMsgStatus.DEACTIVATED}`;
    }

    this.dispatchAddStandardTextEvent();

    this.close();
  }
}

export default ClinicalNotesInstitutionStandardTextController;
